import { Button } from '@ethsign/ui';
import type { ButtonProps } from '@ethsign/ui/dist/Button';
import { cn } from '@ethsign/ui/dist/lib/utils';

export const GradientButton = ({ className, ...props }: ButtonProps) => {
  return <Button size={'lg'} className={cn('tt-border-gradient rounded-lg text-sm', className)} {...props} />;
};
